import api from "../../axios/axios";
import { BookingApiResponse, SelectedBooking, IBooking } from "./IBookings";
import { IFilterRequest } from "./filter/IFilterRequest";
import { ApiRequest, NetworkTypes, handleAndThrowError } from "../ApiError";
import { IUpdateBooking } from "./IUpdate";

const buildParams = (
  forSelected?: boolean,
  filters?: IFilterRequest,
  page?: number,
  pageSize?: number
) => {
  const params = new URLSearchParams({
    CurrentPage: (page ?? 1).toString(),
    PageSize: (pageSize ?? 50).toString(),
  });

  if (forSelected) params.append("Status", "NEW");

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (key === "Status" && forSelected) return; //SKIP OTHER STATUS ONLY NEW STATUS(SELECTABLE STATUS ONLY NEW ONES)
      if (Array.isArray(value)) {
        value.forEach((item) => params.append(key, item));
      } else if (value !== null) {
        params.append(key, value);
      }
    });
  }

  return params;
};

const fetchData = async (
  url: string,
  params: URLSearchParams,
  forSelected: boolean
) => {
  const request: ApiRequest = {
    endPoint: url,
    method: NetworkTypes.GET,
    baseUrl: api.getUri(),
    data: params,
  };

  const response = await api.get(url, { params }).catch((error) => {
    throw handleAndThrowError(error, request);
  });

  if (forSelected) {
    return response.data;
  } else {
    const mappedBookingUnitType: IBooking[] = response.data.results.map(
      (booking: IBooking) => ({
        ...booking,
      })
    );

    return {
      currentPage: response.data.currentPage,
      pageCount: response.data.pageCount,
      pageSize: response.data.pageSize,
      totalRecordCount: response.data.totalRecordCount,
      results: mappedBookingUnitType,
    };
  }
};

export const getBookingsAsync = async (
  page?: number,
  pageSize?: number,
  filters?: IFilterRequest
): Promise<BookingApiResponse> => {
  const params = buildParams(false, filters, page, pageSize);
  const url = "/api/v1/phoenixrailbookingacl";
  return fetchData(url, params, false);
};

export const getAllSelectableBookingsAsync = async (
  filters?: IFilterRequest,
  nonValidateBookings?: SelectedBooking[]
): Promise<SelectedBooking[]> => {
  const params = buildParams(true, filters);

  //IF FILTERED BY BOOKING ID WHEN SENDING BOOKING AND HAD ERROR IN SOME BOOKING
  if (nonValidateBookings !== undefined) {
    const bookingIds = nonValidateBookings.map(
      (nonValidateBooking) => nonValidateBooking.id
    );
    bookingIds.forEach((id) => {
      params.append("BookingIds", id.toString());
    });
  }
  //--------------------

  const url = "/api/v1/phoenixrailbookingacl/selected";
  return fetchData(url, params, true);
};

export const updateBookingAsync = async (
  bookingUpdateRequestDto: IUpdateBooking,
  bookingId: number,
  userName: string
) => {
  const updateRequest = { bookingUpdateRequestDto, bookingId };
  console.log(userName);
  const url = `/api/v1/phoenixrailbookingacl?bookingId=${encodeURIComponent(
    bookingId!
  )}`;

  const request: ApiRequest = {
    endPoint: url,
    method: NetworkTypes.PUT,
    baseUrl: api.getUri(),
    data: updateRequest,
  };

  await api.put(url, bookingUpdateRequestDto).catch((error) => {
    throw handleAndThrowError(error, request);
  });
};

export const getBookingsByIdAsync = async (
  selectedBookings: SelectedBooking[]
): Promise<BookingApiResponse> => {
  const bookingIds = selectedBookings.map(
    (selectedBooking) => selectedBooking.id
  );

  const params = new URLSearchParams({
    CurrentPage: "1",
    PageSize: "50",
  });

  bookingIds.forEach((id) => {
    params.append("BookingIds", id.toString());
  });

  const url = "/api/v1/phoenixrailbookingacl";

  const request: ApiRequest = {
    endPoint: url,
    method: NetworkTypes.GET,
    baseUrl: api.getUri(),
    data: params,
  };

  const response = await api
    .get(url, {
      params: params,
    })
    .catch((error) => {
      throw handleAndThrowError(error, request);
    });

  const bookingsWithUUID: IBooking[] = response.data.results.map(
    (booking: IBooking) => ({
      ...booking,
    })
  );

  const successData: BookingApiResponse = {
    currentPage: response.data.currentPage,
    pageCount: response.data.pageCount,
    pageSize: response.data.pageSize,
    totalRecordCount: response.data.totalRecordCount,
    results: bookingsWithUUID,
  };
  return successData;
};
